import compose from 'ramda/src/compose';

const buildSlide = (slide, options) => {
	slide.classList.add(options.classes.slide);
};

const buildRows = (config) => {
	const slideElement = config.elements.slider;
	if(!slideElement.children){
		console.error('no slides found');
		return;
	}

	let viewportExists = true,
		trackExists = true;

	let viewport = slideElement.querySelector('.' + config.classes.viewport);

	if(!viewport){
		viewport = document.createElement('div');
		viewport.classList.add(config.classes.viewport);
		viewportExists = false;
	}

	let track = slideElement.querySelector('.' + config.classes.track);

	if(!track){
		track = document.createElement('div');
		track.classList.add(config.classes.track);
		trackExists = false;
	}

	if(trackExists){
		for(let i = 0; i < track.children.length; i++){
			buildSlide(track.children[i], config);
		}
	}else{
		let slideParent = slideElement;
		if(viewportExists && !trackExists){
			slideParent = viewport;
		}

		while(slideParent.firstElementChild){
			buildSlide(slideParent.firstElementChild, config);

			if(config.options.buildTrack){
				track.appendChild(slideParent.firstElementChild);
			}
		}
	}

	viewport.appendChild(track);
	slideElement.appendChild(viewport);

	const slides = track.querySelectorAll('.'+config.classes.slide);

	config.elements = Object.assign({}, config.elements, {
		slides,
		viewport,
		track,
		slideElement
	});

	return config;
};

const cleanupInfiniteRows = (config) => {
	const clonedSlides = config.elements.track.querySelectorAll('.' + config.classes.slideClone);
	for (var i = 0; i < clonedSlides.length; i++) {
		clonedSlides[i].remove();
	}

	const slides = config.elements.track.querySelectorAll('.'+config.classes.slide);

	config.elements = Object.assign({}, config.elements, {
		slides
	});

	return config;
};

const buildInifiniteRows = (config) => {
	config = cleanupInfiniteRows(config);
	if(!config.options.infinite || config.options.fade){
		return config;
	}

	const existingClonedSlides = config.elements.track.querySelector(config.classes.slideClone);
	if(existingClonedSlides){
		return config;
	}
	for(let i = 0; i < config.options.slidesToShow; i++){
		const firstSlideClone = config.elements.slides[i].cloneNode(true);
		firstSlideClone.classList.add(config.classes.slideClone);
		config.elements.track.appendChild(firstSlideClone);
	}

	let start = config.elements.slides.length - 1,
		end = config.elements.slides.length - config.options.slidesToShow,
		before = config.elements.slides[0];
	for(let i = start; i >= end; i--){
		const lastSlideClone = config.elements.slides[i].cloneNode(true);
		lastSlideClone.classList.add(config.classes.slideClone);
		config.elements.track.insertBefore(lastSlideClone, before);
		before = lastSlideClone;
	}

	const slides = config.elements.track.querySelectorAll('.'+config.classes.slide);

	config.elements = Object.assign({}, config.elements, {
		slides
	});

	return config;
};

const cleanupArrows = (config) => {
	config.elements.nextArrow && config.elements.nextArrow.remove();
	config.elements.nextArrow = null;
	config.elements.prevArrow && config.elements.prevArrow.remove();
	config.elements.prevArrow = null;

	return config;
};

const buildArrows = (config) => {
	config = cleanupArrows(config);
	if(!config.options.arrows){
		return config;
	}

	if(config.elements.nextArrow && config.elements.nextArrow.innerHTML === config.arrows.next){
		return config;
	}

	const slideElement = config.elements.slider;

	let prevArrow = document.createElement('div');
	prevArrow.innerHTML = config.arrows.prev;
	prevArrow = prevArrow.firstElementChild;

	let nextArrow = document.createElement('div');
	nextArrow.innerHTML = config.arrows.next;
	nextArrow = nextArrow.firstElementChild;

	slideElement.insertBefore(prevArrow, config.elements.viewport);
	slideElement.appendChild(nextArrow);

	config.elements = Object.assign({}, config.elements, {
		nextArrow,
		prevArrow
	});

	return config;
};

const cleanupDots = (config) => {
	config.elements.dotNav && config.elements.dotNav.remove();
	config.elements.dotNav = null;
	config.elements.dots = [];
	return config;
};

const buildDots = (config) => {
	config = cleanupDots(config);

	if(!config.options.dots){
		return config;
	}

	const slideElement = config.elements.slider;

	const dotNav = document.createElement('div');
	dotNav.classList.add(config.classes.dotList);

	let slideCount = config.elements.slides.length;
	if(config.options.infinite && !config.options.fade){
		slideCount = slideCount - (2 * config.options.slidesToShow);
	}

	for(let i = 0; i < slideCount; i++){
		const dotButton = document.createElement('button');
		dotButton.classList.add(config.classes.dot);
		dotButton.innerText = i + 1;
		dotButton.dataset.index = i;
		dotNav.appendChild(dotButton);
	}

	slideElement.appendChild(dotNav);
	const dots = Array.prototype.slice.call(dotNav.querySelectorAll('.'+config.classes.dot));

	config.elements = Object.assign({}, config.elements, {
		dotNav,
		dots
	});

	return config;
};

export const build = (config, slider) => {
	if(!slider){
		console.error('no Element to build slider');
		return;
	}

	config.elements = {
		slider
	};

	config = compose(buildDots, buildArrows, buildInifiniteRows, buildRows)(config);
	return config.elements;
};

export const rebuild = (config) => {
	config = compose(buildDots, buildArrows, buildInifiniteRows)(config);
	return config.elements;
};



// WEBPACK FOOTER //
// ./node_modules/ui-slider/app/js/src/slider/build.js